/**
 * Utility functions for sanitizing values before passing to react-helmet
 * Filters out undefined/null values which can cause react-helmet errors
 */

/**
 * Filters an object to remove undefined and null values
 * @param obj - The object to filter
 * @returns An object without undefined/null values
 */
export const filterProps = <T extends Record<string, unknown>>(obj: T): Partial<T> => {
  const result: Partial<T> = {}
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      result[key as keyof T] = value as T[keyof T]
    }
  })
  return result
}
